import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";

import { common_axios } from "../../../App";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Loader from "../../../components/Loader";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RateReviewIcon from "@mui/icons-material/RateReview";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../../../pages/secure/Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import axios from "axios";
import { dateFormatter } from "../../../helper/helper";
import { CallToActionSharp, CopyAll } from "@mui/icons-material";
import { common } from "@material-ui/core/colors";
import { useRef } from "react";
export default function RatesManagement() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const [open, setOpen] = useState(false);
  const [setStatus, setsetStatus] = useState("");

  const modelReject = useRef(null);
  const modelButtonRejectClose = useRef(null);
  const modelApprove = useRef(null);
  const modelApproveClose = useRef(null);

  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [actions, setactions] = useState(-1);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);

  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [error, setError] = useState(null);

  const rejectUserModal = async (cell) => {
    console.log(cell.row.original);

    await setSelectedUserDetail(cell.row.original);
    await modelReject.current.click();
  };
  const approveUserModal = async (cell) => {
    console.log(cell.row.original);

    await setSelectedUserDetailApprove(cell.row.original);
    await modelApprove.current.click();
  };
  const getAllChannel = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/master/v1/channel/find`,
        {
          status: null,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData1(res.data.bmpChannelMasters);
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  const getAllMessages = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/master/v1/message-type/find`,
        {
          status: null,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData2(res.data.bmpMessageTypeMasters);
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  const getAllMedium = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/master/v1/medium/find`,
        {
          status: null,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setData3(res.data.bmpMediumMasters);
      } else {
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  const getAllRates = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/master/v1/rates/find`,
        {
          status: null,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setData(res.data.rateMasters);
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  const rateUpdates = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/master/v1/rates/update`,
        {
          id: selectedUserDetail.id,
          status: actions,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        getAllRates();
        // await setData([...data, res.data.rateMasters]);
        toast.success("Rate updated successfully", {
          theme: "colored",
        });
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  useEffect(async () => {
    await getAllChannel();
    await getAllMessages();
    await getAllMedium();
    await getAllRates();
  }, []);

  const validationSchema = yup.object({
    name: yup
      .string("Enter your Rate Name")
      .min(3, "Rate Name should be of minimum 3 characters length"),
    //   .required("Rate Name is required"),
    rate: yup
      .string("Enter your Rate ")
      .min(3, "Rate  should be of minimum 3 characters length"),
    //   .required("Rate  is required"),
    channelId: yup.object().nullable(),
    messageMediumTypeId: yup
      .object()
      // .required("messageMediumTypeId is required")
      .nullable(),
    messageTypeId: yup
      .object()
      // .required("messageTypeId is required")
      .nullable(),
    // .required("dltId is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      rate: "",
      channelId: null,
      messageMediumTypeId: null,
      messageTypeId: null,
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_REWARDS}/master/v1/rates/create`,
          {
            name: values.rateName,
            rate: values.rate,
            messageMediumTypeId: values.mediumId?.id,
            messageTypeId: values.messageId?.id,
            channelId: values.channelId?.id,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          await formik.handleReset();

          // await setData([...data, res.data.rateMasters]);
          setOpen(false);
          await getAllRates();

          await toast.success("Created Successfully", {
            theme: "colored",
          });
        } else {
          setOpen(false);

          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } catch (error) {
        formik.handleReset();
        console.log(error);
        setOpen(false);

        await toast.error("Something went wrong !! Please check your network", {
          theme: "colored",
        });
      }
    },
  });

  console.log(actions, "action value");

  const columns = useMemo(
    () => [
      //   {
      //     Header: " Id",

      //     accessor: "id", // accessor is the "key" in the data
      //   },
      //   {
      //     Header: "Created On ",

      //     accessor: "createdOn", // accessor is the "key" in the data
      //     Cell: (cell) => (
      //       <div className="">
      //         {cell.row.original.createdOn ? (
      //           <>{dateFormatter(cell.row.original.createdOn)}</>
      //         ) : (
      //           <>N/A</>
      //         )}

      //         {/* <DeleteIcon /> */}
      //       </div>
      //     ),
      //   },
      {
        Header: "Id",
        Footer: "Id",
        accessor: "id",
        Cell: (cell) => (
          <div className="">
            {cell.row.original.id ? <>{cell.row.original.id}</> : <>N/A</>}

            {/* <DeleteIcon /> */}
          </div>
        ),

        disableFilters: true,
      },
      {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
        Cell: (cell) => (
          <div className="">
            {cell.row.original.name ? <>{cell.row.original.name}</> : <>N/A</>}

            {/* <DeleteIcon /> */}
          </div>
        ),

        disableFilters: true,
      },
      {
        Header: "Channel Name",
        Footer: "Channel Name",
        accessor: "channelName",
        Cell: (cell) => (
          <div className="">
            {cell.row.original.channelName ? (
              <>{cell.row.original.channelName}</>
            ) : (
              <>N/A</>
            )}

            {/* <DeleteIcon /> */}
          </div>
        ),

        disableFilters: true,
      },
      {
        Header: "Message Medium  Name",
        Footer: "Message Medium  Name",
        accessor: "messageMediumTypeName",
        Cell: (cell) => (
          <div className="">
            {cell.row.original.messageMediumTypeName ? (
              <>{cell.row.original.messageMediumTypeName}</>
            ) : (
              <>N/A</>
            )}

            {/* <DeleteIcon /> */}
          </div>
        ),

        disableFilters: true,
      },
      {
        Header: "Message Type Name",
        Footer: "Message Type Name",
        accessor: "messageTypeName",
        Cell: (cell) => (
          <div className="">
            {cell.row.original.messageTypeName ? (
              <>{cell.row.original.messageTypeName}</>
            ) : (
              <>N/A</>
            )}

            {/* <DeleteIcon /> */}
          </div>
        ),

        disableFilters: true,
      },
      {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
        Cell: (cell) => (
          <div className="">
            {cell.row.original.status == 0 ? (
              <>
                <span class="badge bg-warning">Pending</span>
              </>
            ) : cell.row.original.status == 1 ? (
              <>
                <span class="badge bg-success">Approved</span>
              </>
            ) : (
              <>
                <span class="badge bg-danger">Rejected</span>
              </>
            )}

            {/* <DeleteIcon /> */}
          </div>
        ),

        disableFilters: true,
      },
      // {
      //   Header: "Pending",
      //   Footer: "Pending",
      //   accessor: "status",
      //   Cell: (cell) => (
      //     <div className="">
      //       {cell.row.original.status == 0 && (
      //         <>
      //           <span class="badge bg-warning">Pending</span>
      //         </>
      //       )}

      //       {/* <DeleteIcon /> */}
      //     </div>
      //   ),

      //   disableFilters: true,
      // },
      // {
      //   Header: "Approved",
      //   Footer: "Approved",
      //   accessor: "status1",
      //   Cell: (cell) => (
      //     <div className="">
      //       {cell.row.original.status == 1 && (
      //         <>
      //           <span class="badge bg-success">Approved</span>
      //         </>
      //       )}

      //       {/* <DeleteIcon /> */}
      //     </div>
      //   ),

      //   disableFilters: true,
      // },
      // {
      //   Header: "Rejected",
      //   Footer: "Rejected",
      //   accessor: "status2",
      //   Cell: (cell) => (
      //     <div className="">
      //       {cell.row.original.status == -1 && (
      //         <>
      //           <span class="badge bg-danger">Rejected</span>
      //         </>
      //       )}

      //       {/* <DeleteIcon /> */}
      //     </div>
      //   ),

      //   disableFilters: true,
      // },
      {
        Header: "Action",

        accessor: "action",
        Cell: (cell) => {
          console.log(cell, "heko");
          return (
            <div className="dropdown">
              <button
                className="btn color_1 dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons opacity-10 size">person</i>
              </button>

              <>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => {
                        rejectUserModal(cell);
                      }}
                    >
                      <ThumbUpAltIcon
                        style={{ marginRight: "10px", fontSize: "17px" }}
                      />
                      Update
                    </a>
                  </li>
                  {/* <li>
                    <a
                      className="dropdown-item"
                      onClick={() => {
                        approveUserModal(cell);
                      }}
                    >
                      <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                      Approve User
                    </a>
                  </li> */}
                </ul>
              </>
            </div>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          {selectedUserDetail != undefined && (
            <div>
              <button
                ref={modelReject}
                type="button"
                className="btn btn-primary d-none"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop1"
              >
                Launch static backdrop modal
              </button>

              <div
                className="modal fade"
                id="staticBackdrop1"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdrop1Label"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdrop1Label">
                        Rate Updation
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <form onSubmit={""}>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Channel Name
                            </label>
                            <input
                              disabled
                              type="text"
                              value={selectedUserDetail?.channelName}
                              className="form-control"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          </div>

                          <div className="col-md-6 mt_2">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Message Type Name
                            </label>
                            <input
                              disabled
                              type="text"
                              value={selectedUserDetail?.messageTypeName}
                              className="form-control"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          </div>

                          <div className="row mt-2">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label"
                              >
                                Name
                              </label>
                              <input
                                disabled
                                type="text"
                                value={selectedUserDetail?.name}
                                className="form-control"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label"
                              >
                                Rate
                              </label>
                              <input
                                disabled
                                type="text"
                                value={selectedUserDetail?.rate}
                                className="form-control"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                              />
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label"
                              >
                                Sms Count
                              </label>
                              <input
                                disabled
                                type="text"
                                value={selectedUserDetail?.smsCount}
                                className="form-control"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                              />
                            </div>

                            <div className="col-md-6">
                              <label for="cars">Choose Action</label>
                              <select
                                onChange={(e) => setactions(e.target.value)}
                                className="form-select "
                                id="cars"
                                name="cars"
                              >
                                <option value={-1}>Reject </option>
                                <option value={1}>Approve</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-6">
                              <label className="fw-bold mt-3 w-100">
                                Rejected Reason :
                                <select
                                  required
                                  className="form-select mt-2"
                                  name="reason"
                                  id="reason"
                                  onChange={(e) => {
                                    if (e.target.value == "Other") {
                                      selectedUserDetail.rejectedReasonText =
                                        "";
                                    }
                                    setSelectedUserDetail({
                                      ...selectedUserDetail,
                                      rejectedReason: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="Incorrect User Information">
                                    Incorrect User Information
                                  </option>
                                  <option value="Incorrect Documents">
                                    Incorrect Documents
                                  </option>
                                  <option value="Details-Documents Mismatch">
                                    Details-Documents Mismatch
                                  </option>
                                  <option value="Other">Other</option>
                                </select>
                                {selectedUserDetail.rejectedReason ==
                                  "Other" && (
                                  <input
                                    required
                                    className="form-control mt-2"
                                    placeholder="Rejected Reason Here"
                                    type="text"
                                    value={
                                      selectedUserDetail.rejectedReasonText
                                    }
                                    onChange={(e) => {
                                      setSelectedUserDetail({
                                        ...selectedUserDetail,
                                        rejectedReasonText: e.target.value,
                                      });
                                    }}
                                  />
                                )}
                              </label>
                            </div>
                          </div> */}
                      </div>

                      <div class="modal-footer">
                        <button
                          ref={modelButtonRejectClose}
                          type="button"
                          class="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          //   onClick={(e) => {
                          //     setSelectedUserDetail({
                          //       ...selectedUserDetail,
                          //       status: selectedUserDetail?.status == 1 ? 2 : 1,
                          //     });
                          //   }}
                          className="btn btn-primary"
                          onClick={rateUpdates}
                        >
                          {/* {selectedUserDetail?.status == 1
                            ? "Activate"
                            : "De-Activate"} */}
                          Update Rate
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="container-fluid">
            <div className="card">
              <div className="card-header p-3 pt-2">
                <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                  <RateReviewIcon sx={{ color: "white", fontSize: "33px" }} />
                </div>
                <div className="pt-1">
                  <p
                    className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                    style={{ marginLeft: "70px" }}
                  >
                    Add Rate Card
                  </p>
                  <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                    Field(s) marked with{" "}
                    <span className="text-danger fw-bold">*</span> are
                    mandatory.
                  </p>
                </div>
              </div>
              <div className="card-body">
                <div className="card shadow-none border bg_blue">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Add Rate Card
                  </span>

                  <div className="card-body text-lg-start text-center">
                    <form
                      onSubmit={formik.handleSubmit}
                      className="row g-3 needs-validation"
                      novalidate
                    >
                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="Rate Name"
                          name="rateName"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.rateName}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.rateName &&
                            Boolean(formik.errors.rateName)
                          }
                          helperText={
                            formik.touched.rateName && formik.errors.rateName
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="Rate"
                          name="rate"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.rate}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.rate && Boolean(formik.errors.rate)
                          }
                          helperText={formik.touched.rate && formik.errors.rate}
                        />
                      </div>
                      <div className="col-md-4">
                        <Autocomplete
                          disablePortal
                          size="small"
                          className="w-100"
                          id="combo-box-demo"
                          options={data1}
                          getOptionLabel={(option) => `${option.channelName}`}
                          name="channelId"
                          value={formik.values.channelId}
                          onChange={(e, val) => {
                            formik.setFieldValue("channelId", val);
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Channel Name"
                            />
                          )}
                        />
                      </div>

                      <div className="col-md-4">
                        <Autocomplete
                          disablePortal
                          size="small"
                          className="w-100"
                          id="combo-box-demo"
                          options={data2}
                          getOptionLabel={(option) =>
                            `${option.messageTypeName}`
                          }
                          name="messageId"
                          value={formik.values.messageId}
                          onChange={(e, val) => {
                            formik.setFieldValue("messageId", val);
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Message Name"
                            />
                          )}
                        />
                      </div>
                      <div className="col-md-4">
                        <Autocomplete
                          disablePortal
                          size="small"
                          className="w-100"
                          id="combo-box-demo"
                          options={data3}
                          getOptionLabel={(option) => `${option.name}`}
                          name="mediumId"
                          value={formik.values.mediumId}
                          onChange={(e, val) => {
                            formik.setFieldValue("mediumId", val);
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Medium Name"
                            />
                          )}
                        />
                      </div>

                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn bg-gradient-primary m-0"
                        >
                          Submit
                          <ArrowForwardIcon style={{ fontSize: "17px" }} />
                        </button>

                        <button
                          style={{ marginLeft: "6px" }}
                          type="reset"
                          onClick={formik.resetForm}
                          className="btn bg-gradient-secondary m-0 ms-2"
                        >
                          Reset
                          <RestartAltIcon style={{ fontSize: "17px" }} />
                        </button>
                      </div>

                      {/* <div className="row">
                              <div className="col-md-3 mt-3">
                                <button className="btn btn-primary" type="submit">
                                  Submit
                                </button>
                                <button
                                  type="button"
                                  onClick={formik.handleReset}
                                  className="btn btn-secondary"
                                >
                                  Reset
                                </button>
                              </div>
                            </div> */}
                    </form>
                  </div>
                </div>
              </div>

              {data1?.length > 0 && (
                <div className="card-body">
                  <div className="container-fluid p-0">
                    <div className="card shadow-none border bg_blue mt-5">
                      <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                        Recently Added
                      </span>
                      <div className="p-4">
                        <div className="d-flex justify-content-between my-3">
                          <select
                            value={pageSize}
                            className="dropdown"
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                            }}
                          >
                            {[10, 25, 50].map((value, i) => {
                              return (
                                <option
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                  value={value}
                                  key={value}
                                >
                                  {" "}
                                  Show {value}
                                </option>
                              );
                            })}
                          </select>

                          <div></div>
                          <div className="d-flex align-items-center">
                            <span className="d-block">Search</span>
                            <input
                              className="form-control ms-2"
                              type="text"
                              value={globalSearchValue || ""}
                              onChange={(e) => {
                                onChange(e.target.value);
                                setGlobalSearchValue(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div>
                          {selectedFlatRows.length > 0 && (
                            <button onClick={deletUser}>Delete Users</button>
                          )}
                        </div>

                        <table
                          {...getTableProps()}
                          id="example"
                          className="table table-striped table-bordered dataTable table-sm"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            {headerGroups.map((headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                  <th
                                    {...column.getHeaderProps(
                                      column.getSortByToggleProps()
                                    )}
                                    className="text-center width_2"
                                  >
                                    {column.render("Header")}
                                    <span>
                                      {column.isSorted
                                        ? column.isSortedDesc
                                          ? "↑"
                                          : "↓"
                                        : ""}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            ))}
                          </thead>
                          <tbody {...getTableBodyProps()}>
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <tr {...row.getRowProps()}>
                                  {row.cells.map((cell) => {
                                    return (
                                      <td
                                        {...cell.getCellProps()}
                                        className="text-center"
                                      >
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        <div className="d-flex justify-content-between">
                          <div>
                            <span>
                              Page:
                              <strong>
                                {pageIndex + 1} of {pageOptions.length}
                              </strong>
                            </span>

                            <span>
                              | Go to Page :{""}
                              <input
                                type="number"
                                defaultValue={pageIndex + 1}
                                onChange={(e) => {
                                  const pageNumber = e.target.value
                                    ? Number(e.target.value) - 1
                                    : 0;
                                  gotoPage(pageNumber);
                                }}
                                style={{ width: "50px" }}
                              />
                            </span>
                          </div>

                          <div>
                            <button
                              className="btn btn_secondary m-0"
                              type="button"
                              disabled={!canPreviousPage}
                              onClick={() => {
                                previousPage();
                              }}
                            >
                              Prev
                            </button>

                            <button
                              className="btn btn_secondary m-0"
                              type="button"
                              disabled={!canNextPage}
                              onClick={() => {
                                nextPage();
                              }}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
